import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import minesbot from "../assets/img/projects/mines_bot.png";
import personalai from "../assets/img/projects/personal_ai.png";
import elibrary from "../assets/img/projects/e_library.png";
import objectdetect from "../assets/img/projects/object_detection.png";
import vitualmouse from "../assets/img/projects/virtual_mouse.png";
import webanalys from "../assets/img/projects/web_analys.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Mines Bot",
      description: "A Chat Bot gives a info about Mines Law, Rules & Regulations.",
      imgUrl: minesbot,
      githubUrl: "https://github.com/piyush241203",
    },
    {
      title: "Personal AI",
      description: "A Personal AI Assistant operate through Voice and Hand Gesture.",
      imgUrl: personalai,
      githubUrl: "https://github.com/piyush241203",
    },
    {
      title: "E-Library",
      description: "A Platform gives info about Books, Library & provide E-Books.",
      imgUrl: elibrary,
      githubUrl: "https://github.com/piyush241203",
    },
    {
      title: "Object Detection",
      description: "A Machine Learning Model that detects object and gives info.",
      imgUrl: objectdetect,
      githubUrl: "https://github.com/piyush241203",
    },
    {
      title: "Virtual mouse",
      description: "A virtual mouse that operate through Hand & Eye Gesture.",
      imgUrl: vitualmouse,
      githubUrl: "https://github.com/piyush241203",
    },
    {
      title: "Website Analyser",
      description: "Analysis the Website that link we provide.",
      imgUrl: webanalys,
      githubUrl: "https://github.com/piyush241203",
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>Developed various projects using Python and other Technologies.<br/>And demonstrating expertise in AI, machine learning, and web development. These projects showcase my ability to integrate modern technologies and innovative solutions effectively.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Tab 3</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <p>We working on Some Projects that are Available in Future.<br/>If you have some Idea about Project then try to Connect with Us by Sending Message.</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>We Working on Some Projects that are Available in Future.<br/>If you have some Idea about Project then try to Connect with Us by Sending Message.</p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
